import React from 'react';
import { profile } from '../data/profile';
import { MagneticButton } from './ui/MagneticButton';
import { SocialLink } from './ui/SocialLink';
import { Reveal } from '../lib/motion';
import { Icon } from '../lib/Icon';

export default function Footer() {
  return (
    <footer id="contato" style={{ position: 'relative', padding: 'clamp(5rem,12vw,9rem) clamp(20px,5vw,56px) 3rem', borderTop: '1px solid var(--border-subtle)', overflow: 'hidden' }}>
      <div aria-hidden="true" style={{ position: 'absolute', inset: 0, background: 'radial-gradient(120% 80% at 50% 120%, var(--yellow-a08), transparent 60%)', pointerEvents: 'none' }} />
      <div style={{ position: 'relative', maxWidth: 'var(--container-wide)', margin: '0 auto', textAlign: 'center' }}>
        <Reveal>
          <span className="t-eyebrow" style={{ display: 'block', marginBottom: 20 }}>{'// Vamos trabalhar juntos'}</span>
          <h2 style={{ fontSize: 'var(--text-display)', lineHeight: 1.05, marginBottom: 36 }}>
            Tem um problema difícil?<br /><span style={{ color: 'var(--accent)' }}>Vamos resolver.</span>
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 48 }}>
            <MagneticButton onClick={() => { window.location.href = 'mailto:' + profile.email; }}>
              <Icon name="mail" size={18} /> {profile.email}
            </MagneticButton>
          </div>
        </Reveal>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, marginBottom: 48 }}>
          <SocialLink label="GitHub" href={profile.github} icon={<Icon name="github" size={20} />} />
          <SocialLink label="LinkedIn" href={profile.linkedin} icon={<Icon name="linkedin" size={20} />} />
          <SocialLink label="Email" href={'mailto:' + profile.email} icon={<Icon name="mail" size={20} />} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, paddingTop: 28, borderTop: '1px solid var(--border-subtle)', fontFamily: 'var(--font-mono)', fontSize: 'var(--text-xs)', color: 'var(--text-muted)' }}>
          <span>© {new Date().getFullYear()} Bernardo Assad</span>
          <span>Feito em São Paulo</span>
        </div>
      </div>
    </footer>
  );
}
